import { Stack, Theme, alpha } from '@mui/material';

type CommandPaletteResultProps = {
  children: React.ReactNode;
  onClick?: () => void;
};

function CommandPaletteResult({ onClick, children }: CommandPaletteResultProps) {
  let sx = {};

  if (onClick) {
    sx = {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
      },
    };
  }

  return (
    <Stack onClick={onClick} px={2} py={1.5} borderRadius={1} sx={sx}>
      {children}
    </Stack>
  );
}

export default CommandPaletteResult;
